
export { gtmViewEsyncAlerts } from "./GTM"